import { generateActionCreator as generate, reduxTypes as types } from 'ggtmo-utils';

// eslint-disable-next-line import/prefer-default-export
export const EDITOR_TOGGLE_DELETE_CONFIRM_MODAL = generate('EDITOR_TOGGLE_DELETE_CONFIRM_MODAL', { type: types.SYNC });
